export var IvfTreatmentCycle;
(function (IvfTreatmentCycle) {
    IvfTreatmentCycle["first"] = "1";
    IvfTreatmentCycle["second"] = "2";
    IvfTreatmentCycle["third"] = "3";
    IvfTreatmentCycle["other"] = "O";
})(IvfTreatmentCycle || (IvfTreatmentCycle = {}));
IvfTreatmentCycle['first'] = '1';
IvfTreatmentCycle['second'] = '2';
IvfTreatmentCycle['third'] = '3';
IvfTreatmentCycle['other'] = 'O';
//# sourceMappingURL=IvfTreatmentCycle.js.map